import { notification } from "antd";
import { useContext } from "react";
import { IonModal, IonButton, IonButtons, IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import AppContext from "../../contexts/AppContext";
import ImageModifierForm from "./components/ImageModifierForm";
import "./styles.css";

const ImageModifier = ({ isModalVisible, setIsModalVisible }) => {
  const [, contextHolder] = notification.useNotification();

  return (
    <>
      {contextHolder}
      <IonModal
        isOpen={isModalVisible}
        onDidDismiss={() => setIsModalVisible(false)}
        style={{
          "--height": "auto",
          "--max-height": "90vh",
          "--width": "800px",
          "--max-width": "95%",
          "--border-radius": "16px",
          "--box-shadow": "0 20px 40px rgba(0, 0, 0, 0.3)",
          "--z-index": "10000",
        }}
      >
        <div style={{ position: "relative", height: "auto" }}>
          <IonButtons 
            style={{ 
              position: "absolute", 
              top: "16px", 
              right: "16px", 
              zIndex: 1000,
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "50%",
              padding: "4px",
              backdropFilter: "blur(10px)",
            }}
          >
            <IonButton 
              fill="clear" 
              onClick={() => setIsModalVisible(false)}
              style={{ 
                color: "white",
                "--border-radius": "50%",
                width: "40px",
                height: "40px",
              }}
            >
              <IonIcon icon={closeOutline} style={{ fontSize: "20px" }} />
            </IonButton>
          </IonButtons>
          <ImageModifierForm 
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
          />
        </div>
      </IonModal>
    </>
  );
};

export default ImageModifier; 